'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/competitor-fares-chart-tooltip.html'));
var CompetitorFaresChartFormattersService = function CompetitorFaresChartFormattersService($filter, momentService, chartFormatter, competitorFaresTooltipService) {
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  function getTimeString(moment) {
    return rmMomentFormat(moment, momentService.TIME_USER_SETTINGS);
  }
  function removeCarrierNameFromFltNbrList(item) {
    return item.fltNbrList.split(item.carrier).join('');
  }
  function getChartFormatters(filterModeCallback) {
    return {
      xAxisTickFormatter: chartFormatter.humanReadable,
      yAxisTickFormatter: chartFormatter.humanReadable,
      checkForMatchedFilter: function checkForMatchedFilter() {
        return filterModeCallback() === 'MATCHED';
      },
      tooltipFormatter: function tooltipFormatter(data) {
        var isMatched = filterModeCallback() === 'MATCHED';
        var dataPoints = _.chain(data).forEach(function (item) {
          item.value = parseFloat(item.value);
          item.fareLabel = rmNumberFormat(item.value, 'CURRENCY_LONG');
          var dptrMoment = momentService.of(item.departureTime, momentService.FIELD.DEPARTURE_TIME, momentService.FORMAT.TIME_ISO);
          item.departureTime = getTimeString(dptrMoment);
          if (isMatched && item.fltNbrList) {
            item.fltNbrList = removeCarrierNameFromFltNbrList(item);
          }
        }).orderBy(['value'], ['desc']).value();
        var arrayChunks = competitorFaresTooltipService.splitDataToColumns(dataPoints);
        var tooltipModel = {
          numColumns: arrayChunks.length,
          arrayChunks: arrayChunks,
          dataPoints: dataPoints,
          isMatched: isMatched
        };
        return tooltipTemplate(tooltipModel);
      }
    };
  }
  return {
    getChartFormatters: getChartFormatters
  };
};
CompetitorFaresChartFormattersService.$inject = ['$filter', 'MomentService', 'FormatterService', 'CompetitorFaresTooltipService'];
module.exports = CompetitorFaresChartFormattersService;